import { useState, useEffect } from 'react';
import { usePayment } from '../Providers/PaymentProvider';

const usePaymentFlow = () => {
    const { paymentCreate } = usePayment();
    const [paymentUrl, setPaymentUrl] = useState(null)

    useEffect(() => {
        if (paymentUrl?.length > 0) {
            window.location.href = paymentUrl
        }
    }, [paymentUrl]);

    const createPaymentAndRedirect = async (params) => {
        const url = await paymentCreate(params)
        setPaymentUrl(url);
    };

    return { createPaymentAndRedirect }
};

export default usePaymentFlow;
